import { useTranslation } from 'react-i18next';
import { Building2, ShoppingBag, ArrowRight } from 'lucide-react';
import { Section, Container, Button } from '../../ui';
import styles from './BuyChannels.module.css';

export function BuyChannels() {
  const { t } = useTranslation('home');

  return (
    <Section variant="gray">
      <Container>
        <div className={styles.header}>
          <span className={styles.badge}>{t('buyChannels.badge')}</span>
          <h2 className={styles.heading}>{t('buyChannels.heading')}</h2>
          <p className={styles.subtitle}>{t('buyChannels.subtitle')}</p>
        </div>

        <div className={styles.grid}>
          <div className={styles.card}>
            <div className={styles.cardIcon}>
              <Building2 size={24} strokeWidth={1.5} />
            </div>
            <h3 className={styles.cardTitle}>{t('buyChannels.pro.title')}</h3>
            <p className={styles.cardText}>{t('buyChannels.pro.text')}</p>
            <div className={styles.cardActions}>
              <Button
                href="https://pro.quelbonplan.fr"
                className={styles.cardCta}
                data-umami-event="cta-shop-pro"
                data-umami-event-location="home-buychannels"
                data-attr="cta-shop-pro"
              >
                {t('buyChannels.pro.cta')}
                <ArrowRight size={16} strokeWidth={1.5} />
              </Button>
              <span className={styles.cardHint}>{t('buyChannels.pro.hint')}</span>
            </div>
          </div>

          <div className={styles.card}>
            <div className={styles.cardIcon}>
              <ShoppingBag size={24} strokeWidth={1.5} />
            </div>
            <h3 className={styles.cardTitle}>{t('buyChannels.perso.title')}</h3>
            <p className={styles.cardText}>{t('buyChannels.perso.text')}</p>
            <div className={styles.cardActions}>
              <Button
                href="https://quelbonplan.fr"
                variant="secondary"
                className={`${styles.cardCta} ${styles.cardCtaPerso}`}
                data-umami-event="cta-shop-perso"
                data-umami-event-location="home-buychannels"
                data-attr="cta-shop-perso"
              >
                {t('buyChannels.perso.cta')}
                <ArrowRight size={16} strokeWidth={1.5} />
              </Button>
              <span className={styles.cardHint}>{t('buyChannels.perso.hint')}</span>
            </div>
          </div>
        </div>
      </Container>
    </Section>
  );
}
